/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetEditionsCartQueryVariables = Exact<{
	filter?: Types.Editions_Filter | null | undefined;
	dropConfigFilter?: Types.Drop_Config_Filter | null | undefined;
}>;

export type GetEditionsCartQuery = {
	Editions: Array<{
		id: string;
		name: string | null;
		code: string;
		width_cm: string | null;
		length_cm: string | null;
		dimensions_description: string | null;
		artists: Array<{
			Artists_id: { name: string | null } | null;
		} | null> | null;
		series: { code: string | null; name: string | null } | null;
		product: {
			id: string;
			sku: string;
			currency: string;
			price: number;
		} | null;
		image: {
			filename_disk: string | null;
			width: number | null;
			height: number | null;
		} | null;
	}>;
	Drop_Config: Array<{ id: string }>;
};

export const GetEditionsCartDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getEditionsCart' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'filter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Editions_filter' },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'dropConfigFilter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Drop_Config_filter' },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Editions' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'filter' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'code' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'width_cm' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'length_cm' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'dimensions_description' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artists' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'Artists_id' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'name' },
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'series' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'code' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'product' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'sku' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'currency' },
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'price' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'image' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ImageWithDimensions' },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Drop_Config' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'dropConfigFilter' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageWithDimensions' },
			typeCondition: {
				kind: 'NamedType',
				name: { kind: 'Name', value: 'directus_files' },
			},
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'filename_disk' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'height' } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetEditionsCartQuery,
	GetEditionsCartQueryVariables
>;
